import React, { useState } from "react";
import Collapsible from "react-collapsible";
import styles from "./DoubleSentenceStatic.module.css";
import LessonInstruction from "../../containers/instruction/LessonInstruction";

const DoubleSentenceStatic = ({ data, en, audioUrl }) => {
  const [open, setOpen] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  return (
    <div className="default-card container new-bg-color">
      {data.type === "instruction" ? (
        <LessonInstruction
          instructionText={data.instruction}
          audioUrl={audioUrl}
        />
      ) : (
        <div style={{ width: "100%" }}>
          <h2>
            <Collapsible
              className="collapse-opened"
              contentOuterClassName={styles.customContentOuter}
              contentInnerClassName={styles.customContentInner}
              triggerTagName="div"
              triggerOpenedClassName={styles.customTriggerOpened}
              trigger={en ? data.en : data.pt}
              open={open}
              handleTriggerClick={() => setOpen(open)}
              onClosing={() => setIsClosing(true)}
              onOpening={() => setIsClosing(false)}
            >
              {en ? data.pt : data.en}
            </Collapsible>
          </h2>
        </div>
      )}
    </div>
  );
};

export default DoubleSentenceStatic;
